// ALL THE ROUTES USED IN THE APP

export const apiRoutes = {
    login : '/login',
    
}